import React from 'react';

import { Box, Checkbox, HStack, Stack } from '@chakra-ui/react';
import { customTheme } from 'theme';

import { PermissionsActionsIcon } from 'components/Icons';
import { radioBoxStyles } from 'containers/Setup/CloudAccounts/CloudAccountWizard/styles';
import { DataPolicyManagementHelp } from 'containers/Setup/CloudAccounts/types';

import { RegionsForDataPolicyManagement } from './RegionsForDataPolicyManagement';

export const reviewDataAccessPermissionsMessage = (
  isConfirm: boolean,
  setIsConfirm: (value: boolean) => void,
) => (
  <Box {...radioBoxStyles}>
    <Stack
      spacing={0}
      onClick={() => setIsConfirm(!isConfirm)}
      cursor="pointer"
    >
      <HStack>
        <Checkbox size="lg" isChecked={isConfirm} />
        <Box color="primary">
          I have created a cross-account IAM Role to manage data policies
        </Box>
      </HStack>
      <Box fontSize="sm" color={customTheme.colors.gray[250]} pl={7}>
        Click here to view steps to create a cross-account IAM Role
      </Box>
    </Stack>
  </Box>
);

export const dataPolicyManagementHelpHeaderMapping = (
  type: typeof DataPolicyManagementHelp,
) => {
  switch (type) {
    case DataPolicyManagementHelp.RegionDataPolicyManagement:
      return {
        header: 'Specifying regions for data policy management',
        content: <RegionsForDataPolicyManagement />,
        icon: <PermissionsActionsIcon />,
      };
  }
};
